export function isStatusPerfilEnabled(settings) {
	if (!Array.isArray(settings)) return false;
	const setting = settings.find((item) => item.key === "StatusPerfil");
	return setting?.value === "enabled";
}
